import React from 'react'
import CustomDrawer from 'components/shared-components/CustomDrawer'
import MediModel from '../MediModel'

const SelectMediaModel = ({
  openMediaModel,
  handleCancelMediaModel,
  HandleUploadImage,
  requestType,
  handleCustomMedia,
  mediaKindFilter = null,
  mediaUserId = null,
}) => {
    return (
        <CustomDrawer
            title="Select Media"
            open={openMediaModel}
            onClose={handleCancelMediaModel}
            width={1200}
        >
            <MediModel
                HandleUploadImage={HandleUploadImage}
                requestType={requestType}
                handleCustomMedia={handleCustomMedia}
                mediaKindFilter={mediaKindFilter}
                mediaUserId={mediaUserId}
            />
        </CustomDrawer>
    )
}

export default SelectMediaModel

